import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import qs from 'query-string';

import { removeAndGetLogoutCallbackEntities } from 'src/shared/utils/sessionStorageManager';

import currentUrlUtils from 'src/shared/utils/currentUrlUtils';
import { CommonProps } from '../../components/helpers/props';
import useAuthStore from 'src/hooks/auth/useAuthStore';
import config from 'src/shared/config';

export interface LogoutProps extends CommonProps {
  contextPath: string;
  redirectsignIn: string;
  isAuthenticated: boolean;
  isProgressSignOut: boolean;
  signOut: () => Promise<void>;
  finishSignOut: () => {
    payload: undefined;
    type: string;
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
async function fetchWithTimeout(resource: string, timeout: number, options: RequestInit) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
}

const Logout: React.FC<LogoutProps> = ({
  contextPath,
  redirectsignIn,
  isAuthenticated,
  isProgressSignOut,
  signOut,
  finishSignOut,
}) => {
  const history = useNavigate();
  const [localProgressSignOut, setLocalProgressSignOut] = useState(true);
  console.log(`Logout called with ${isAuthenticated}`);

  useEffect(() => {
    console.log(`Logout.useEffect.isAuthenticated : ${isAuthenticated}`);

    if (isAuthenticated) {
      // call idP logout
      const promiseSignOutIdP = signOut().catch((e) => {
        // do nothing
      });
      // call other SP logout callbacks
      const logoutCallbackEntities = removeAndGetLogoutCallbackEntities();
      const promiseSignOutSPs = logoutCallbackEntities.map(({ logoutUrl, token }) => {
        const params = new URLSearchParams();
        params.append('bearer', token);

        // return axios
        // .delete<void>(logoutUrl, { data: params, timeout: 3000 })
        // .catch((e) => {
        //   // do nothing;
        // });

        return fetchWithTimeout(logoutUrl, 3000, {
          method: 'DELETE',
          body: JSON.stringify(params),
        }).catch((e) => {
          // do nothing;
        });
      });
      Promise.all([promiseSignOutIdP, ...promiseSignOutSPs]).then(() => {
        finishSignOut();
        setLocalProgressSignOut(false);
      });
    } else {
      finishSignOut();
      setLocalProgressSignOut(false);
    }
  }, [isAuthenticated, signOut, history, finishSignOut]);

  if (!isProgressSignOut && !localProgressSignOut) {
    // console.log('Logout sign-out done & redirect');
    const redirectUrl = currentUrlUtils.getFirstQuery('redirectUrl') || `${contextPath}`; // config.url('/');

    return (
      <Navigate
        to={qs.stringifyUrl({
          url: redirectsignIn, //config.url('/sign-in'),
          query: {
            redirectUrl,
          },
        })}
      />
    );
  }

  return null;
};

const LogoutOutside: React.FC = () => {
  const { isAuthenticated, isProgressSignOut, signOut, finishSignOut } = useAuthStore();

  return (
    <Logout
      contextPath={config.contextPath}
      redirectsignIn={config.url('/main')}
      isAuthenticated={isAuthenticated}
      isProgressSignOut={isProgressSignOut}
      signOut={signOut}
      finishSignOut={finishSignOut}
    />
  );
};

export default LogoutOutside;
